module.exports = __webpack_public_path__ + "static/img/nut_003.69923cd0.png";